(() => {
  const originals = new WeakMap();
  const notes = new WeakMap();
  const captions = new WeakMap();
  function marked(node, property, active) {
    if (!originals.has(node)) originals.set(node, {});
    const saved = originals.get(node);
    if (!(property in saved)) saved[property] = node[property];
    const base = saved[property] || '';
    node[property] = active && !/\*\s*$/.test(base) ? base + ' *' : base;
  }
  function update(form) {
    let hasRequired = false;
    form.querySelectorAll('input, select, textarea').forEach(field => {
      if (['hidden', 'submit', 'button', 'reset'].includes(field.type)) return;
      const active = field.required && !field.disabled;
      hasRequired = hasRequired || active;
      const labels = Array.from(field.labels || []);
      labels.forEach(label => {
        let marker = label.querySelector('[data-janine-required-marker]');
        if (active && !marker && !label.textContent.includes('*')) {
          marker = document.createElement('span');
          marker.dataset.janineRequiredMarker = '';
          marker.setAttribute('aria-hidden', 'true');
          marker.textContent = ' *';
          label.appendChild(marker);
        }
        if (marker) marker.hidden = !active;
      });
      if (field.placeholder) marked(field, 'placeholder', active);
      if (field.tagName === 'SELECT' && field.options.length && field.options[0].value === '') {
        marked(field.options[0], 'textContent', active);
        const wrapper = field.parentElement;
        const display = wrapper.querySelector('.selected-text');
        if (display && field.selectedIndex === 0) display.textContent = field.options[0].textContent;
      }
      if (field.type === 'date' || field.type === 'time') {
        let caption = captions.get(field);
        if (!caption) {
          caption = document.createElement('small');
          caption.style.cssText = 'display:block;margin:0 0 6px;font:inherit;font-size:12px;';
          field.before(caption);
          captions.set(field, caption);
        }
        caption.textContent = (field.getAttribute('aria-label') || labels[0]?.textContent || (field.type === 'time' ? 'Time' : 'Date')).replace(/\s*\*\s*$/, '') + (active ? ' *' : '');
      }
    });
    if (form.closest('.jf-newsletter')) return;
    let note = notes.get(form);
    if (hasRequired && !note) {
      note = document.createElement('p');
      note.dataset.janineRequiredNote = '';
      note.textContent = '* Required fields';
      note.style.cssText = 'display:block;width:100%;margin:12px 0 0;font:inherit;font-size:12px;line-height:1.5;color:inherit;';
      const contactSubmit = form.matches('.jct-form') && form.querySelector('.jct-form__button');
      const firstField = form.querySelector('input[name="janine_theme_id"]') && form.querySelector('.ja-form__field, .jct-field');
      if (firstField) {
        note.style.margin = '0 0 12px';
        firstField.before(note);
      } else if (contactSubmit) contactSubmit.before(note);
      else form.after(note);
      notes.set(form, note);
    }
    if (note) note.hidden = !hasRequired;
  }
  function init(root) {
    root.querySelectorAll('form').forEach(form => {
      if (form.dataset.janineRequiredReady) return;
      form.dataset.janineRequiredReady = 'true';
      update(form);
      new MutationObserver(() => update(form)).observe(form, {subtree:true, attributes:true, attributeFilter:['required','disabled']});
      form.addEventListener('change', () => update(form));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();